<template>
  <div class="charge-detail">
    <div class="main">
      <div class="list">
        <div class="name-label">{{ $t('lang.Equipment number') }}</div>
        <div class="value-label">{{ deviceInfo.primaryDeviceNo }}</div>
        <div class="name-label">{{ $t('lang.Equipment qr code') }}</div>
        <div class="value-label" style="width: 4%">
          {{ deviceInfo.qrcodeBindStatus == 1 ? $t('lang.bound') : $t('lang.unbound') }}
        </div>
        <el-upload
          class="value-label"
          style="width: 100px"
          action
          accept=".jpg, .jpeg, .png, .gif, .bmp, .pdf, .JPG, .JPEG, .PBG, .GIF, .BMP, .PDF"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="bindQrcode"
        >
          <div
            class="ml10"
            style="color: #67aa42;width: 100%"
          >{{ deviceInfo.qrcodeBindStatus == 1 ? $t('lang.Replace QR code') : $t('lang.Binding QR code') }}
          </div>
        </el-upload>
        <div class="value-label" style="color: #67aa42;cursor: pointer;width: 80px;" v-if="deviceInfo.link"
             @click="qrcodeDialogVisible = true">{{ $t('lang.View QR code') }}
        </div>
        <div class="name-label">{{ $t('lang.Communication board number') }}</div>
        <div class="value-label">{{ deviceInfo.communicationBoardNo }}</div>
        <div class="name-label">{{ $t('lang.version') }}</div>
        <div class="value-label">{{ deviceInfo.version ? versionMap[deviceInfo.version] : "" }}</div>
      </div>
      <div class="list">
        <div class="name-label">{{ $t('lang.Equipment name') }}</div>
        <div class="value-label">{{ deviceInfo.deviceName }}</div>
        <div class="name-label">{{ $t('lang.Power status of equipment') }}</div>
        <div class="value-label">
          {{ $t('lang.' + $changeObj(primary_Device_Charge_Status_Code)[deviceInfo.primaryDeviceChargeStatusCode]) }}
        </div>
        <div class="name-label">{{ $t('lang.Equipment service status') }}</div>
        <div
          class="value-label"
          style="width: 163px"
        >
          {{
            deviceInfo.enableStatus == 1 ? $t('lang.Enable') : (deviceInfo.enableStatus == 0 ? $t('lang.unenable') : '')
          }}
        </div>
        <div class="name-label">{{ $t('lang.Equipment type') }}</div>
        <div class="value-label">{{ $t('lang.' + $changeObj(device_Info_type)[deviceInfo.typeCode]) }}</div>
      </div>
      <div class="list">
        <div class="name-label">{{ $t('lang.Replaceable battery spec') }}</div>
        <div class="value-label">{{ supportBatteryVoltageList }}</div>
        <div class="name-label">{{ $t('lang.Used electricity') }}</div>
        <div class="value-label">{{ deviceInfo.useElectricityDegree }}</div>
        <!-- <div class="name-label">所属代理商：</div>
        <div class="value-label">{{deviceInfo.useElectricityDegree}}</div>
        <div class="name-label">所属门店：</div>
        <div class="value-label">{{deviceInfo.useElectricityDegree}}</div> -->
      </div>
      <div class="list">
        <!--        <div class="name-label">{{$t('lang.Location address')}}</div>
                <div class="value-label" style="width:433px;max-width: 433px">{{deviceInfo.location}}</div>-->
        <div class="name-label">{{ $t('lang.Delivery address') }}</div>
        <div class="value-label" style="width:43%;max-width: 43%">{{ deviceInfo.showPlacingPosition }}</div>
      </div>
      <div class="list">
        <div class="blue-btn" @click="onQueryBtnClick(deviceInfo.primaryDeviceNo)">
          {{ $t('lang.View equipment snapshot') }}
        </div>
        <div
          class="blue-btn ml10"
          style="width: 100px"
          @click="onQueryRecordClick(deviceInfo.primaryDeviceNo)"
        >{{ $t('lang.View the sending request record') }}
        </div>
        <div class="blue-btn ml10" @click="onDevicePowerOnClick(deviceInfo.primaryDeviceNo)">
          {{ $t('lang.electricity') }}
        </div>
        <div class="blue-btn ml10" @click="onDevicePowerOffClick(deviceInfo.primaryDeviceNo)">
          {{ $t('lang.Power cut') }}
        </div>
        <div
          class="blue-btn ml10"
          style="width: 100px"
          @click="onQueryReasonClick(deviceInfo.primaryDeviceNo)"
        >{{ $t('lang.View the ops operation record') }}
        </div>
        <!--<div class="blue-btn ml10" v-if="!deviceInfo.qrCodeIsSynchro" @click="onDeviceUploadQrCodeClick(deviceInfo.primaryDeviceNo)">上传二维码</div>-->
      </div>
      <el-table
        :data="recordList"
        style="width: 100%;margin-bottom: 20px;"
      >
        <!-- :tree-props="{ children: 'subMenuList', hasChildren: 'true' }" -->
        <el-table-column width="120" prop="chargePortSeqNo" :label="$t('lang.Port number')"></el-table-column>
        <el-table-column width="150" prop="statusCode" :label="$t('lang.Port state')">
          <template slot-scope="{row}">
            {{ $t('lang.' + $changeObj(status_Code_port)[row.statusCode]) }}
          </template>
        </el-table-column>
        <el-table-column width="150" :label="$t('lang.Port current/voltage')">
          <template slot-scope="{row}">
            {{ $t('lang.current') }}：{{ row.electricCurrent }}
            <br/>
            {{ $t('lang.voltage') }}：{{ row.electricVoltage }}
          </template>
        </el-table-column>
        <el-table-column width="150" prop="enableStatusCode" :label="$t('lang.Port service status')">
          <template slot-scope="{row}">
            <div>{{ $t('lang.' + $changeObj(enable_Status_Code)[row.enableStatusCode]) }}</div>
            <el-button size="mini" type="primary" @click="changeStatus(row)">{{ $t('lang.Change status'+row.enableStatusCode) }}</el-button>
          </template>
        </el-table-column>
        <el-table-column width="200" :label="$t('lang.Port charged amount/Charging time')">
          <template slot-scope="{row}">
            {{ $t('lang.Charged amount') }}：{{ row.electricityCostDegree }}
            <br/>
            {{
              $t('lang.Charging time')
            }}：{{ row.chargeTimeLength >= 0 ? row.chargeTimeLength + $t('lang.minutes') : "--" }}
          </template>
        </el-table-column>
        <el-table-column width="200" :label="$t('lang.Battery current/voltage/Voltage difference')">
          <template slot-scope="{row}">
            {{ $t('lang.current') }}：{{ row.batteryCurrent }}
            <br/>
            {{ $t('lang.voltage') }}：{{ row.batteryVoltage }}
            <br/>
            {{ $t('lang.Voltage difference') }}：{{ row.voltageDifference }}
          </template>
        </el-table-column>
        <el-table-column width="200" :label="$t('lang.Battery Power/Health level')">
          <template slot-scope="{row}">
            {{ $t('lang.electricity') }}：{{ row.soc }}
            <br/>
            {{ $t('lang.Health level') }}：{{ row.soh }}
          </template>
        </el-table-column>
        <el-table-column width="150" prop="batteryCommunicationBoardNo"
                         :label="$t('lang.Port battery SN')"></el-table-column>
        <el-table-column width="250" prop="sort" :label="$t('lang.The highest battery temperature/lowest')">
          <template slot-scope="{row}">
            {{ $t('lang.Maximum temperature') }}：{{ row.maxTemperature }}
            <br/>
            {{ $t('lang.Minimum temperature') }}：{{ row.minTemperature }}
          </template>
        </el-table-column>
        <el-table-column width="200" prop="sort" :label="$t('lang.MOS Temperature charging/discharge')">
          <template slot-scope="{row}">
            {{ $t('lang.Charging temperature') }}：{{ row.chargingMosTemperature }}
            <br/>
            {{ $t('lang.Discharge temperature') }}：{{ row.dischargeMosTemperature }}
          </template>
        </el-table-column>
        <el-table-column width="150" prop="loopFrequency" :label="$t('lang.Battery cycle number')">
          <template slot-scope="{row}">
            {{ row.loopFrequency }}
          </template>
        </el-table-column>
        <el-table-column width="150" prop="doorStatusCode" :label="$t('lang.State of cabinet door')">
          <template slot-scope="{row}">
            {{ $t('lang.' + $changeObj(door_Status_Code)[row.doorStatusCode]) }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" :label="$t('lang.Refresh time')" width="200"></el-table-column>
        <el-table-column width="150" prop="sort" :label="$t('lang.Monomer voltage')">
          <template slot-scope="{row}">
            <div class="text-btn" v-if="row.batteryNo" @click="onCellVoltageBtnClick(row)">{{ $t('lang.To view') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.Operating')" width="300" fixed="right">
          <template slot-scope="{row}">
            <div class="mb10">
              <el-button size="mini" type="primary" @click="onOpenDoorClick(row)">{{ $t('lang.Open the door') }}
              </el-button>
              <el-button size="mini" type="primary" @click="onRefreshBtnClick(row)">{{ $t('lang.refresh') }}</el-button>
            </div>
            <el-button size="mini" type="primary" @click="onPowerOnBtnClick(row)">{{ $t('lang.electricity') }}
            </el-button>
            <el-button size="mini" type="primary" @click="onPowerOffBtnClick(row)">{{ $t('lang.Power cut') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="dfcc">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          layout="prev, next"
          @current-change="handleCurrentChange"
          :total="total">
        </el-pagination>
      </div> -->
    </div>
    <el-dialog :title="$t('lang.Please specify the reason for disabling the port:')" :visible.sync="dialogVisible"
               width="30%">
      <el-input type="textarea" :rows="2" :placeholder="$t('lang.Please specify the reason for disabling the port:')"
                v-model="serviceUnableReason"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="oncancelBtnClick">{{ $t('lang.Cancel') }}</el-button>
        <el-button type="primary" @click="onConfirmBtnClick">{{ $t('lang.Confirm') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('lang.View cell voltage')" width="610px" :visible.sync="cellVoltageDialogVisible" center>
      <div class="list">
        <span>{{ $t('lang.time') }}</span>
        <el-date-picker
          v-model="cellVoltageStartTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.start time')"
          size="mini"
          class="ml-10"
          @change="onCellVoltageQueryClick"
        ></el-date-picker>
        <el-date-picker
          v-model="cellVoltageEndTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.end time')"
          size="mini"
          class="ml-10"
          @change="onCellVoltageQueryClick"
        ></el-date-picker>
      </div>
      <div class="list mt-10">
        <span>{{ $t('lang.Cell voltage number') }}</span>
        <el-select class="fixed-width-100 ml-10" size="mini" v-model="cellSeqNo" @change="onCellVoltageQueryClick">
          <el-option
            v-for="(item) in cellSeqNoList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button type="primary ml-10 w-100" size="mini" @click="onCellVoltageQueryClick">{{ $t('lang.Inquire') }}
        </el-button>
      </div>
      <el-table v-loading="loading" :data="tableData" style="width: 100%" class="mt-10">
        <el-table-column prop="createTime" :label="$t('lang.Receiving time')" width="230"></el-table-column>
        <el-table-column prop="cellSeqNo" :label="$t('lang.Cell voltage number')"></el-table-column>
        <el-table-column prop="electricVoltage" :label="$t('lang.voltage')"></el-table-column>
      </el-table>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="primary w-100"
          @click="onCellVoltagePrePageClick"
          :disabled="cellVoltageBeginIndex <= 0"
        >上一页</el-button>
        <el-button
          size="mini"
          type="primary w-100 ml-10"
          @click="onCellVoltageNextPageClick"
          :disabled="!cellVoltageHasNext"
        >下一页</el-button>
      </span> -->
    </el-dialog>
    <el-dialog :title="$t('lang.View QR code')" :visible.sync="qrcodeDialogVisible" width="30%">
      <el-image :src="qrcodeSrc"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="qrcodeDialogVisible = false">{{ $t('lang.Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  primary_Device_Charge_Status_Code,
  device_Info_type,
  status_Code_port,
  enable_Status_Code,
  door_Status_Code
} from '@/utils/constant'
import Utils from "../../utils/utils";
import {wholeDeviceInfo} from '@/api/deviceManagement';
import {editChargePortEnableStatus} from "../../api/deviceManagement";

export default {
  name: "batterySwapMgmtDetailView",
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      door_Status_Code,
      status_Code_port,
      device_Info_type,
      enable_Status_Code,
      primary_Device_Charge_Status_Code,
      primaryDeviceNo: '',
      total: 0,
      recordList: [],
      deviceInfo: {},
      supportBatteryVoltageList: "",
      versionMap: {
        "1": "v1.0",
        "2": "v2.0",
        "3": "v3.0",
        "4": "v3.1",
        "5": "v4.0"
      },
      operateMap: {
        1: this.$t('lang.energized'),
        2: this.$t('lang.Power out')
      },
      qrCode: "",
      qrcodeSrc: "",
      preBtnDisabled: true,
      nextBtnDisabled: false,
      dialogVisible: false,
      qrcodeDialogVisible: false,
      editChargePortNo: "",
      serviceUnableReason: "",
      dataList: [],
      curPage: 0,
      dataListTotal: [],
      cellVoltageDialogVisible: false,
      cellSeqNoList: [],
      cellSeqNo: "",
      cellVoltageStartTime: '',
      cellVoltageEndTime: '',
      cellVoltageBeginIndex: 0,
      cellVoltagePageSize: 5,
      tableData: [],
      loading: false,
      batteryInfo: {},
      cellVoltageHasNext: true,
      domainType: '',
      domainList: ['iot.lititi.com', 'hailixinnengyuan.com'],
      timeObj: '',
    };
  },
  watch: {
    editData: {
      handler(val) {
        this.primaryDeviceNo = val.primaryDeviceNo;
        // this.wholeDeviceInfo();
        // this.recordList = [val];
        // this.
        // this.primaryDeviceNo = this.editData.primaryDeviceNo;
        this.queryChargeDetail();

      },
      deep: true
    }
  },
  mounted() {
    this.cellVoltageEndTime = Utils.timeHandle().endTime;
    this.cellVoltageStartTime = Utils.timeHandle().startTime;
    // this.wholeDeviceInfo();
    // this.queryChargeDetail();

  },
  methods: {
    // 详情
    /*async wholeDeviceInfo() {
      const params = {
        primaryDeviceNo: this.primaryDeviceNo
      };
      try {
        const res = await wholeDeviceInfo(params);
        this.recordList = res.mdata.deviceInfo.chargePortList;
        this.deviceInfo = res.mdata.deviceInfo;
        if (res.mdata.deviceInfo.link) {
          this.getQrcodeSrc(res.mdata.deviceInfo.link);
        }
      } catch (e) {
        console.log(e);
      }
    },*/
    // 分页
    handleCurrentChange(i) {

    },

    onCellVoltageQueryClick() {
      this.cellVoltageBeginIndex = 0;
      this.cellVoltageHasNext = true;
      this.queryBatteryCellSnapshot(this.batteryInfo);
    },
    getQrcodeSrc(url) {
      console.log('getQrcodeSrc');
      let self = this;
      let params = {
        link: url
      }
      this.$http
        .post(
          "/managementPlatform/electricity/queryQrCode",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            return;
          }
          self.qrcodeSrc = res.mdata['qrCode:']
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    cancelHandle() {
      this.view = "list";
    },
    bindQrcode(file) {
      let url = URL.createObjectURL(file.raw);
      this.$qrcode.decodeFromImage(url).then(res => {
        if (this.domainType == '2') {
          let flag = false;
          this.domainList.forEach(v => {
            if (res.data.indexOf(v) > -1) {
              flag = true;
            }
          })
          if (!flag) {
            this.$message.error(this.$t('lang.Wrong QR code'));
            return;
          }
        }
        this.qrCode = Utils.getQueryParam(res.data, "qrcode");
        this.bindQrCodeToDevice();
      });
    },
    bindQrCodeToDevice() {
      let self = this;
      let params = {
        cabinetNo: this.deviceInfo.primaryDeviceNo,
        qrcode: this.qrCode,
        reconfirm: 0
      };
      this.$http
        .post(
          "/managementPlatform/electricity/bindQRCode",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          if (res.mdata.needReconfirm == 1) {
            self
              .$confirm(res.mdata.msg, "", {
                confirmButtonText: self.$t('lang.Confirm'),
                cancelButtonText: self.$t('lang.Cancel'),
                type: "warning"
              })
              .then(() => {
                self.reconfirm = 1;
                self.bindQrCodeToDevice();
              })
              .catch(action => {
              });
          } else {
            self.$message({
              type: "success",
              message: self.$t('lang.Successful'),
              center: true
            });
            self.deviceInfo.qrcodeBindStatus = "1";
          }
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    changeStatus(item) {
      let self = this;
      this.editChargePortNo = item.chargePortNo;
      if (item.enableStatusCode == 1) {
        this.dialogVisible = true;
      } else {
        this.$confirm(self.$t('lang.Are you sure you want to enable this port?'), "", {
          confirmButtonText: self.$t('lang.Confirm'),
          cancelButtonText: self.$t('lang.Cancel'),
          type: "warning"
        })
          .then(() => {
            self.changePortStatus(1);
          })
          .catch(action => {
          });
      }
    },
    oncancelBtnClick() {
      this.dialogVisible = false;
      this.serviceUnableReason = "";
    },
    onConfirmBtnClick() {
      let self = this;
      this.$confirm(self.$t('lang.Make sure to deactivate the port'), "", {
        confirmButtonText: self.$t('lang.Confirm'),
        cancelButtonText: self.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.dialogVisible = false;
          self.changePortStatus(0, this.serviceUnableReason);
        })
        .catch(action => {
        });
    },
    queryChargeDetail() {
      console.log('queryChargeDetail');

      // this.showData();
      let self = this;
      let params = {
        primaryDeviceNo: this.primaryDeviceNo
      };
      // /managementPlatform/electricity/wholeDeviceInfo
      this.$http
        .get(
          "/managementPlatform/thailand/wholeDeviceInfo?primaryDeviceNo=" + this.primaryDeviceNo,
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message || self.$t('lang.Query failed'),
              center: true
            });
            return;
          }
          self.recordList = res.mdata.deviceInfo.chargePortList.map((el) => {
            return {
              ...el,
              updateTime: self.$changeTime.showTime(el.updateTime)
            }
          });
          self.deviceInfo = res.mdata.deviceInfo;
          // self.deviceInfo = res.mdata.deviceInfo;
          if (res.mdata.deviceInfo.link) {
            self.getQrcodeSrc(res.mdata.deviceInfo.link);
          }
          let list = self.deviceInfo.supportBatteryVoltageList
            ? JSON.parse(self.deviceInfo.supportBatteryVoltageList)
            : [];
          list.forEach(v => {
            v += "V";
          });
          self.supportBatteryVoltageList = list.join("，");
          console.log(self.supportBatteryVoltageList, 'self.supportBatteryVoltageList1');
          self.dataListTotal = res.mdata.deviceInfo.chargePortList;
          // self.showData();
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    async changePortStatus(status, reason) {
      let self = this;
      let params = {
        enableStatus: status,
        chargePortNo: this.editChargePortNo
      };
      if (reason) {
        params.serviceUnableReason = reason;
      }
      try {
        await editChargePortEnableStatus(params)
        self.$message({
          type: "success",
          message: self.$t('lang.Successful'),
          center: true
        });
        self.queryChargeDetail();
      } catch (e) {
        console.log(e);
      }
    },
    // 查看快照
    onQueryBtnClick(data) {
      let searchCondition = this.editData.searchCondition;
      this.$router.push(
        "/managePage/snapShot?primaryDeviceNo=" +
        data +
        "&type=2&searchCondition=" +
        searchCondition.searchCondition +
        "&deviceName=" +
        searchCondition.deviceName +
        "&beginIndex=" +
        searchCondition.beginIndex
      );
    },
    // 查看发送记录
    onQueryRecordClick(data) {
      let searchCondition = this.editData.searchCondition;
      this.$router.push(
        "/managePage/sendRecord?primaryDeviceNo=" +
        data +
        "&searchCondition=" +
        searchCondition.searchCondition +
        "&deviceName=" +
        searchCondition.deviceName +
        "&beginIndex=" +
        searchCondition.beginIndex
      );
    },
    // 查看运维记录
    onQueryReasonClick(data) {
      let searchCondition = this.editData.searchCondition;
      this.$router.push(
        "/managePage/stopReason?primaryDeviceNo=" +
        data +
        "&searchCondition=" +
        searchCondition.searchCondition +
        "&deviceName=" +
        searchCondition.deviceName +
        "&beginIndex=" +
        searchCondition.beginIndex
      );
    },
    // 柜子通电
    onDevicePowerOnClick(primaryDeviceNo) {
      let self = this;
      let operate = 1;
      this.$confirm(this.$t('lang.Whether to confirm the power'), "", {
        confirmButtonText: self.$t('lang.Confirm'),
        cancelButtonText: self.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.operateDevice(primaryDeviceNo, operate);
        })
        .catch(action => {
        });
    },
    // 柜子断电
    onDevicePowerOffClick(primaryDeviceNo) {
      let self = this;
      let operate = 2;
      this.$confirm(self.$t('lang.Whether to confirm the power cut'), "", {
        confirmButtonText: self.$t('lang.Confirm'),
        cancelButtonText: self.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.operateDevice(primaryDeviceNo, operate);
        })
        .catch(action => {
        });
    },
    onDeviceUploadQrCodeClick(primaryDeviceNo) {
      let self = this;
      let operate = 16;
      this.$confirm(this.$t('lang.Whether determine the sync upload the qr code'), "", {
        confirmButtonText: self.$t('lang.Confirm'),
        cancelButtonText: self.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.operateDevice(primaryDeviceNo, operate);
        })
        .catch(action => {
        });
    },
    operateDevice(primaryDeviceNo, operate) {
      let self = this;
      let params = {
        primaryDeviceNo: primaryDeviceNo,
        operate: operate
      };
      this.$http
        .post(
          "/managementPlatform/electricity/operate",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: self.$t('lang.Successful'),
            center: true
          });
          self.deviceInfo.primaryDeviceChargeStatus = this.operateMap[operate];
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    // 单体电压，查看按钮
    onCellVoltageBtnClick(data) {
      this.cellVoltageBeginIndex = 0;
      this.cellVoltageHasNext = true;
      this.batteryInfo = data;
      this.queryCellSeqNoList(data.batteryNo);
      this.queryBatteryCellSnapshot(data);
      this.cellVoltageDialogVisible = true;
    },
    // 开门按钮
    onOpenDoorClick(data) {
      let chargePortNo = data.chargePortNo;
      let operate = 3;
      let self = this;
      this.$confirm(data.chargePortSeqNo + self.$t('lang.is sure open cupboard door'), "", {
        confirmButtonText: self.$t('lang.Confirm'),
        cancelButtonText: self.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.operateChargePort(chargePortNo, operate);
        })
        .catch(action => {
        });
    },
    // 刷新按钮
    onRefreshBtnClick(data) {
      this.queryChargeDetail();
    },
    // 列表通电按钮
    onPowerOnBtnClick(data) {
      let chargePortNo = data.chargePortNo;
      let operate = 1;
      let self = this;
      this.$confirm(this.$t('lang.Whether to confirm the power'), "", {
        confirmButtonText: self.$t('lang.Confirm'),
        cancelButtonText: self.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.operateChargePort(chargePortNo, operate);
        })
        .catch(action => {
        });
    },
    // 列表断电按钮
    onPowerOffBtnClick(data) {
      let chargePortNo = data.chargePortNo;
      let operate = 2;
      let self = this;
      this.$confirm(self.$t('lang.Whether to determine the power'), "", {
        confirmButtonText: self.$t('lang.Confirm'),
        cancelButtonText: self.$t('lang.Cancel'),
        type: "warning"
      })
        .then(() => {
          self.operateChargePort(chargePortNo, operate);
        })
        .catch(action => {
        });
    },
    operateChargePort(chargePortNo, operate) {
      let self = this;
      let params = {
        chargePortNo: chargePortNo,
        operate: operate
      };
      this.$http
        .post(
          "/managementPlatform/electricity/operate",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.$message({
            type: "success",
            message: self.$t('lang.Successful'),
            center: true
          });
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    queryCellSeqNoList(batteryNo) {
      let self = this;
      let params = {
        batteryNo: batteryNo
      };
      this.$http
        .post(
          "/managementPlatform/electricity/queryBatteryCellSeqNoList",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.cellSeqNoList = res.ldata;
        })
        .catch(function (response) {
          console.log(response);
        });
    },
    // 查看按钮请求
    queryBatteryCellSnapshot(data) {
      this.loading = true;
      let self = this;
      let params = {
        batteryNo: data.batteryNo,
        cellSeqNo: self.cellSeqNo,
        startTime: self.cellVoltageStartTime,
        endTime: self.cellVoltageEndTime,
        beginIndex: self.cellVoltageBeginIndex,
        pageSize: self.cellVoltagePageSize
      };
      this.$http
        .post(
          "/managementPlatform/electricity/queryBatteryCellSnapshot",
          this.$qs.stringify(params)
        )
        .then(function (response) {
          let res = response.data;
          if (!res || !res.result) {
            self.$message({
              type: "error",
              message: res.message,
              center: true
            });
            return;
          }
          self.tableData = res.ldata;
          if (self.tableData.length < self.cellVoltagePageSize) {
            self.cellVoltageHasNext = false;
          } else {
            self.cellVoltageHasNext = true;
          }
          self.tableData.forEach(item => {
            item.electricVoltage += "V";
            item.cellSeqNo += self.$t('lang.No');
          });
          self.loading = false;
        })
        .catch(function (response) {
          self.loading = false;
          console.log(response);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  display: flex;
  // line-height: 30px;
  margin: 0 30px;
  overflow: hidden;

  .name-label {
    float: left;
    margin-left: 30px;
  }

  .value-label {
    float: left;
    // width: 17%;
    // max-width: 17%;
    height: 30px;
    margin-left: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }

  .blue-btn {
    margin-bottom: 10px;
  }
}

.table-custom {
  overflow-x: scroll;

  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #bee6b3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.ml-10 {
  margin-left: 10px;
}

.w-100 {
  width: 100px;
}

.mt4 {
  margin-top: 4px;
}

.mt-10 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/batterySwapMgmtDetailView.vue